import {
  Breadcrumb,
  Breadcrumbs,
} from '@monorepo/shared/componentsV2/Breadcrumbs';
import { Toolbar } from '@monorepo/shared/componentsV2/Toolbar';
import { contentPaddingValue } from '@monorepo/shared/styles/layout';
import { header4 } from '@monorepo/shared/styles/text';
import React from 'react';
import styled from 'styled-components';

const StyledToolbar = styled(Toolbar)`
  padding: 0.5rem 0;
`;

const BelowBreadcrumbsContainer = styled.div`
  flex-shrink: 0;
  padding: 0 1rem 0.5rem;

  @media (min-width: 600px) {
    padding-right: ${contentPaddingValue};
    padding-left: ${contentPaddingValue};
  }
`;

const BreadcrumbsContainer = styled.div`
  flex-grow: 1;
  padding: 0 2rem 0 0;
`;

const StyledBreadcrumbs = styled(Breadcrumbs)`
  ${header4}
  padding: 0;
`;

type SecondaryBreadcrumbToolbarProps = {
  belowBreadcrumbs?: React.ReactNode;
  crumbs: Breadcrumb[];
  rightActions?: React.ReactNode;
};

export function SecondaryBreadcrumbToolbar({
  belowBreadcrumbs,
  crumbs,
  rightActions,
}: SecondaryBreadcrumbToolbarProps) {
  return (
    <>
      <StyledToolbar
        leftActions={
          <BreadcrumbsContainer>
            <StyledBreadcrumbs crumbs={crumbs} />
          </BreadcrumbsContainer>
        }
        rightActions={rightActions}
        size="auto"
        variant="noDropShadow"
      />
      {belowBreadcrumbs && (
        <BelowBreadcrumbsContainer>
          {belowBreadcrumbs}
        </BelowBreadcrumbsContainer>
      )}
    </>
  );
}
